// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"02c81989","453":"979298b0","508":"52c4543e","726":"816655bb","776":"cda51c96"}[chunkId] + ".chunk.js";
};